// // // src/components/BranchYearSemSelector.tsx
// // // Yahan pe Branch/year/sem select karne ka UI hai

// // import React from "react";

// // export default function BranchYearSemSelector({
// //   Branch, setBranch, year, setYear, semester, setSemester, curriculum
// // }: {
// //   Branch: string, setBranch: (g: string)=>void,
// //   year: string, setYear: (y: string)=>void,
// //   semester: string, setSemester: (s: string)=>void,
// //   curriculum: any
// // }) {
// //   const years = Object.keys(curriculum);
// //   const semesters = Object.keys(curriculum[year]);
// //   const Branchs = Object.keys(curriculum[year][semester]);

// //   return (
// //     <div className="flex flex-wrap gap-4 mb-4">
// //       <select value={year} onChange={e=>setYear(e.target.value)} className="p-2 rounded bg-black text-cyan-300">
// //         {years.map(y => <option key={y}>{y}</option>)}
// //       </select>
// //       <select value={semester} onChange={e=>setSemester(e.target.value)} className="p-2 rounded bg-black text-cyan-300">
// //         {semesters.map(s => <option key={s}>{s}</option>)}
// //       </select>
// //       <select value={Branch} onChange={e=>setBranch(e.target.value)} className="p-2 rounded bg-black text-cyan-300">
// //         {Branchs.map(g => <option key={g}>{g}</option>)}
// //       </select>
// //     </div>
// //   );
// // }
// // BranchYearSemSelector.tsx
// import React from "react";

// export default function BranchYearSemSelector({
//   Branch, setBranch, year, setYear, semester, setSemester, curriculum
// }: {
//   Branch: string, setBranch: (g: string) => void,
//   year: string, setYear: (y: string) => void,
//   semester: string, setSemester: (s: string) => void,
//   curriculum: any
// }) {
//   const years = Object.keys(curriculum);
//   const semesters = curriculum[year] ? Object.keys(curriculum[year]) : [];
//   const Branchs = curriculum[year]?.[semester] ? Object.keys(curriculum[year][semester]) : [];

//   // Map displayed Branch names
//   const displayBranch = (g: string) => {
//     if (year === "Second Year" && semester === "Semester 3") return "C";
//     return g;
//   };

//   return (
//     <div className="flex flex-wrap gap-4 mb-4">
//       <select 
//         value={year} 
//         onChange={e => {
//           setYear(e.target.value);
//           setSemester(Object.keys(curriculum[e.target.value])[0]);
//         }}
//         className="p-2 rounded bg-black text-cyan-300"
//       >
//         {years.map(y => <option key={y}>{y}</option>)}
//       </select>

//       <select 
//         value={semester} 
//         onChange={e => {
//           setSemester(e.target.value);
//           setBranch(Object.keys(curriculum[year][e.target.value])[0]);
//         }}
//         className="p-2 rounded bg-black text-cyan-300"
//       >
//         {semesters.map(s => <option key={s}>{s}</option>)}
//       </select>

//       <select 
//         value={Branch} 
//         onChange={e => setBranch(e.target.value)}
//         className="p-2 rounded bg-black text-cyan-300"
//       >
//         {Branchs.map(g => (
//           <option key={g} value={g}>
//             {displayBranch(g)}
//           </option>
//         ))}
//       </select>
//     </div>
//   );
// }
// BranchYearSemSelector.tsx

import React from "react";

export default function BranchYearSemSelector({
  Branch, setBranch, year, setYear, semester, setSemester, curriculum
}: {
  Branch: string, setBranch: (g: string) => void,
  year: string, setYear: (y: string) => void,
  semester: string, setSemester: (s: string) => void,
  curriculum: any
}) {
  const years = Object.keys(curriculum);
  const semesters = curriculum[year] ? Object.keys(curriculum[year]) : [];
  const Branchs = curriculum[year]?.[semester] ? Object.keys(curriculum[year][semester]) : [];

  // Map displayed Branch names
  const displayBranch = (g: string) => {
    if (year === "Second Year" && semester === "Semester 3" && g === "CSBS") return "C";
    return g;
  };

  return (
    <div className="flex flex-wrap gap-4 mb-4">
      <select 
        value={year} 
        onChange={e => {
          const newYear = e.target.value;
          setYear(newYear);
          setSemester(Object.keys(curriculum[newYear])[0]);
        }}
        className="p-2 rounded bg-black text-cyan-300"
      >
        {years.map(y => <option key={y} value={y}>{y}</option>)}
      </select>

      <select 
        value={semester} 
        onChange={e => {
          const newSemester = e.target.value;
          setSemester(newSemester);
          setBranch(Object.keys(curriculum[year][newSemester])[0]);
        }}
        className="p-2 rounded bg-black text-cyan-300"
      >
        {semesters.map(s => <option key={s} value={s}>{s}</option>)}
      </select>

      <select 
        value={Branch} 
        onChange={e => setBranch(e.target.value)}
        className="p-2 rounded bg-black text-cyan-300"
      >
        {Branchs.map(g => (
          <option key={g} value={g}>
            {displayBranch(g)}
          </option>
        ))}
      </select>
    </div>
  );
}
